<template>
    <router-link :to="link" class="dac">
        <div class="dac__icon" :class="iconClass">
            <i :class="iconName"></i>
        </div>
        <div class="dac__body">
            <span class="dac__label">{{ title }} Assets</span>
            <span class="dac__count">{{ assetCount }}</span>
            <span class="dac__amount">&#8377; {{ formatAmount(assetAmount) }}</span>
        </div>
        <div class="dac__arrow"><i class="fas fa-chevron-right"></i></div>
    </router-link>
</template>

<script>
export default {
    props: {
        title: { type: String, default: "" },
        assetCount: { type: Number, default: 0 },
        assetAmount: { type: Number, default: 0 },
        link: { type: String, default: "/asset-allocations" },
    },
    computed: {
        iconClass() {
            const t = (this.title || "").toLowerCase()
            if (t.includes("non") || t.includes("unalloc")) return "dac__icon--amber"
            if (t.includes("alloc")) return "dac__icon--green"
            return "dac__icon--blue"
        },
        iconName() {
            const t = (this.title || "").toLowerCase()
            if (t.includes("non") || t.includes("unalloc")) return "fas fa-box-open"
            if (t.includes("alloc")) return "fas fa-user-check"
            return "fas fa-boxes"
        },
    },
    methods: {
        formatAmount(val) {
            if (!val && val !== 0) return "0"
            return Number(val).toLocaleString("en-IN")
        },
    },
}
</script>

<style lang="scss" scoped>
@import "../../assets/variables.scss";

.dac {
    display: flex; align-items: center; gap: 14px;
    background: white; border: 1px solid $gray100; border-radius: 10px;
    padding: 16px 18px; text-decoration: none;
    transition: all $transitionFast; cursor: pointer;
    &:hover { border-color: $gray200; box-shadow: $shadowMd; transform: translateY(-2px); .dac__arrow { opacity: 1; color: $primaryColor; } }
}
.dac__icon {
    width: 44px; height: 44px; border-radius: 10px; flex-shrink: 0;
    display: flex; align-items: center; justify-content: center; font-size: 18px;
    &--blue { background: #eff6ff; color: #2563eb; }
    &--green { background: #f0fdf4; color: #16a34a; }
    &--amber { background: #fffbeb; color: #d97706; }
}
.dac__body {
    flex: 1; display: flex; flex-direction: column; min-width: 0;
}
.dac__label {
    font-size: 11.5px; font-weight: 600; color: $gray400; text-transform: uppercase; letter-spacing: .3px;
}
.dac__count {
    font-size: 22px; font-weight: 800; color: $gray800; line-height: 1.2;
}
.dac__amount {
    font-size: 12.5px; font-weight: 600; color: $gray500; margin-top: 1px;
}
.dac__arrow {
    font-size: 12px; color: $gray300; opacity: 0.5; transition: all $transitionFast; flex-shrink: 0;
}
</style>
